import { getInstance } from "./container";

import type { ClassConstructor } from "./container";

export function ProvideCreate<TDeps extends Record<string, object>>(deps: {
  [K in keyof TDeps]: ClassConstructor<TDeps[K]>;
}) {
  return function <
    TClass,
    TInstance extends TClass & { [K in keyof TDeps]: TDeps[K] },
  >(target: TClass): TClass {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const originalCreate = (target as TClass & { create(): TInstance }).create;

    (target as TClass & { create(): TInstance }).create =
      function (): TInstance {
        const instance = originalCreate();

        (Object.keys(deps) as Array<keyof TDeps>).forEach((key) => {
          const depClass = deps[key];
          (instance as { [K in keyof TDeps]: TDeps[K] })[key] =
            getInstance(depClass);
        });

        (target as TClass & { instance: TInstance }).instance = instance;
        return instance;
      };

    return target;
  };
}
